import styled from "styled-components";
import Col from "antd/es/col";
import Row from "antd/es/row";
import Flex from "common/Boxes/Flex";
import { useContext } from "react";
import IconWithFallback from "Global/IconWithFallback";
import Text from "common/Typography/Text";
import { ICON_TYPES } from "@shared/common/constants";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import OrderNumber from "common/Numbering/OrderNumber";

const ExistingQuantityOrder = () => {
  const { quantity, quantityCoin, quantityAmount, amountCoin, currentPrice } =
    useContext(TradingTerminalContext)!;

  return (
    <Wrapper>
      <Col span={12}>
        <Flex
          $justifyContent={"start"}
          $alignItems={"center"}
          style={{ height: "100%" }}
        >
          <OrderNumber displayNumber={1} />
          <Text as={"div"}>{currentPrice}</Text>
        </Flex>
      </Col>
      <Col span={12}>
        <Flex $flexDirection={"column"} $alignItems={"start"}>
          <Flex>
            <IconWithFallback
              iconType={ICON_TYPES.COIN}
              coinOrExchangeName={quantityCoin}
              iconStyle={{ marginRight: 6 }}
            />
            <Text>{quantity}</Text>
          </Flex>
          <Flex>
            <IconWithFallback
              iconType={ICON_TYPES.COIN}
              coinOrExchangeName={amountCoin}
              iconStyle={{ marginRight: 6 }}
            />
            <Text>{quantityAmount}</Text>
          </Flex>
        </Flex>
      </Col>
    </Wrapper>
  );
};

export default ExistingQuantityOrder;

const Wrapper = styled(Row)`
  height: 45px;
  margin-bottom: 16px;
`;
